import React, { useEffect, useState } from 'react'
import Icon from '@mdi/react'
import { Link } from 'react-router'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { Formik, Form as FormikForm } from 'formik'
import { mdiAccountOutline, mdiCamera, mdiCarOutline, mdiCheck, mdiMotorbike } from '@mdi/js'
import Logo from '@assets/logo_tema_horizontal.png'
import Form from '@components/Form'
import Button from '@components/Button'
import ButtonGroup from '@components/Button/Group'
import { setFoto } from '@modules/convite/reducers/conviteReducer'
import { saveConvite } from '@modules/convite/controllers/conviteController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import formatDate from '@utils/Date/formatDate'
import { useQuery } from '@utils/queryParams'
import conditionaRender from '@utils/conditionalRender'
import RenderDynamicFields from '@utils/dynamicFields/components/RenderDynamicFields'
import { createDynamicFieldsFormSchema, createDynamicFieldsFormValues } from '@utils/dynamicFields'

const ViewCadastro: React.FC = () => {

    const dispatch = useAppDispatch()
    const { convite, conviteCampos, foto, dadosConvite } = useAppSelector(s => s.convite)
    const { requestGetConviteCampos, requestSaveConvite } = useAppSelector(s => s.requestConvite)

    const [check, setCheck] = useState(false)
    const [showDadosVeiculos , setShowDadosVeiculo] = useState(0)

    const idVisitante = useQuery().get("idVisitante")

    const CR = conditionaRender(requestGetConviteCampos, conviteCampos)

    const handleChange = (event: SelectChangeEvent) => {
        setShowDadosVeiculo(Number(event.target.value));
    }

    useEffect(() => {
        if(convite && convite.visitanteCampo){
            if(convite.visitanteCampo.tipoEntrada === 'Pedestre'){
                setShowDadosVeiculo(0)
            }else if(convite.visitanteCampo.tipoEntrada === 'Moto'){
                setShowDadosVeiculo(1)
            }else if(convite.visitanteCampo.tipoEntrada === 'Carro'){
                setShowDadosVeiculo(2)
            }
        } 
    }, [convite, setShowDadosVeiculo])

    return(

        <div id="conviteCadastroWrapper">
            {CR.ERROR && <span>{requestGetConviteCampos.message}</span>}
            {(CR.DATA && !!conviteCampos) && (
                <>
                    {dadosConvite && (
                        <>
                            <div
                                id="logoContainer"
                                style={{ fontSize: '16px', textAlign: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}
                            >
                                <img src={Logo} alt='' style={{ width: '255px', padding: '12.4488px' }} />
                                <p style={{ fontSize: '16px', color: '#6A7178', paddingBottom: '10px' }}>Olá, <span style={{ fontWeight: 'bold', color: '#101213' }}>{dadosConvite.nomeVisitante}</span></p>
                                <p style={{ fontSize: '16px', color: '#6A7178', paddingBottom: '10px' }}><span style={{ fontWeight: 'bold', color: '#101213' }}>{dadosConvite.nomeMorador} </span>
                                    enviou uma autorização para que você
                                    acesse o <span style={{ fontWeight: 'bold', color: '#101213' }}>{dadosConvite.condominio} </span>
                                    no período de
                                    <span style={{ fontWeight: 'bold', color: '#101213' }}> {formatDate(dadosConvite.dtInicio)}</span>
                                    &ensp;à
                                    <span style={{ fontWeight: 'bold', color: '#101213' }}> {formatDate(dadosConvite.dtFim)}</span>
                                </p>
                                <p style={{ paddingTop: '2px', fontSize: '16px', color: '#6A7178', paddingBottom: '10px' }}>
                                    Para confirmar seu acesso é necessário, {false && <span style={{ fontWeight: 'bold', color: '#101213' }}> enviar uma foto</span>}  <span style={{ fontWeight: 'bold', color: '#101213' }}> preencher os dados </span>  abaixo
                                </p>
                            </div>
                        </>
                    )}
                    {dadosConvite.flagFoto && 
                        <Link
                            // to = {`/convite/foto/?idVisitante=${idVisitante}`}
                            to = {`/convite/liveness/?idVisitante=${idVisitante}`}
                            className={`button-foto `}
                            style={{ flex: 'none', width: '96px', height: '96px', paddingBottom: '10px', backgroundImage: `url("${foto}")` }}
                        >
                            <div >
                                {!foto && <Icon path={mdiCamera} size="40px" className='picture-botton' />}
                                {/* {!!foto && <p>foto</p>} */}
                            </div>
                        </Link>
                    }
                    <Formik
                        initialValues={createDynamicFieldsFormValues(conviteCampos!, convite!.visitanteCampo ?? undefined)}
                        validationSchema={createDynamicFieldsFormSchema(conviteCampos!)}
                        onSubmit={v => saveConvite(dispatch, v, convite!.visitanteConvidado!.id, idVisitante!, convite!.visitanteConvidado!.idTipoVisitante, foto, check, showDadosVeiculos, dadosConvite.flagFoto)}
                    >
                        {({ handleSubmit, setFieldValue, resetForm, values, errors }) => {
                            return (
                                <FormikForm>
                                    <Form.Container padding={false}>
                                        <Form.Row columns={1}>
                                            <RenderDynamicFields
                                                fields={conviteCampos!}
                                                values={values}
                                                errors={errors}
                                                setFieldValue={setFieldValue} />

                                        </Form.Row>
                                        <Form.Row columns={1}>
                                            <div  className='divSelect'>
                                                <label className='labelSelect'>Informação de acesso</label>
                                                <Select
                                                    value={showDadosVeiculos.toString()}
                                                    className='select'
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem value={0}> <div style={{display:'flex'}} ><Icon path={mdiAccountOutline} size={1}  /> &nbsp; <label>Pedestre </label></div></MenuItem>
                                                    <MenuItem value={1}><div style={{display:'flex'}} ><Icon path={mdiMotorbike} size={1} /> &nbsp; <label>Moto </label></div></MenuItem>
                                                    <MenuItem value={2}><div style={{display:'flex'}} ><Icon path={mdiCarOutline} size={1} /> &nbsp; <label>Carro </label></div></MenuItem>
                                                </Select>
                                            </div>
                                            {(showDadosVeiculos > 0) && (
                                                <>
                                                    <Form.Group
                                                        label = {'Marca'}
                                                        inputID = {'marca'}
                                                        inputName = {'marca'}
                                                        inputType = {'undefined'}
                                                        
                                                        error={(errors as any)['marca']}
                                                    />
                                                    <Form.Group
                                                        label = {'Modelo'}
                                                        inputID = {'modelo'}
                                                        inputName = {'modelo'}
                                                        inputType = {'undefined'}
                                                        error={(errors as any)['modelo']}
                                                    />
                                                    <Form.Group
                                                        label = {'Placa'}
                                                        inputID = {'placa'}
                                                        inputName = {'placa'}
                                                        inputType = {'undefined'}
                                                        error={(errors as any)['placa']}
                                                    />
                                                </>
                                            )}
                                        </Form.Row>

                                        <div className='termsContainer'>
                                            <Checkbox color='error' checked={check} onChange={() => setCheck(!check)} inputProps={{ 'aria-label': 'controlled' }} />
                                            <label className='error' style={{ fontSize: '16px', color: '#6A7178' }}> Concordo de fornecer meus dados para acesso ao <span style={{ fontWeight: 'bold', color: '#101213' }}>{dadosConvite?.condominio}</span> </label>
                                        </div>

                                        <ButtonGroup>
                                            <Button
                                                theme="outline"
                                                label="Limpar"
                                                onClick={() => {
                                                    resetForm()
                                                    dispatch(setFoto(''))
                                                }} />
                                            <Button
                                                icon={mdiCheck}
                                                label="Salvar"
                                                status={(Object.values(errors).length > 0 || !check) ? "disabled" : "success"}
                                                loading={requestSaveConvite.loading}
                                                onClick={handleSubmit} />
                                        </ButtonGroup>
                                    </Form.Container>
                                </FormikForm>
                            )
                        }}
                    </Formik>
                </>
            )}
        </div>

    )

}

export default ViewCadastro